import { Module } from 'vuex'
import { GlobalDataProps, actionWrapper } from './index'
import { ListData, RespData } from './respTypes'

export interface OrderData {
  _id: string;
  amount: number;
  status: 0 | 1 | 2;
  paymentMethod: string;
  planName: string;
  statusObj?: { type: string; text: string };
  createdAt: string;
  updatedAt: string;
}

export interface OrderProps {
  data: OrderData[];
  count: number;
}

const order: Module<OrderProps, GlobalDataProps> = { 
  state: { 
    data: [],
    count: 0
  },
  mutations: {
    getOrdersAdmin(state, rawData: ListData<OrderData[]>) {
      const { data, count } = rawData.data
      state.data = data
      state.count = count
    },
  },
  actions: { 
    getOrdersAdmin: actionWrapper('/api/ordersAdmin', 'getOrdersAdmin', { disableCaching: true }),
  }
}

export default order